/* ========================================
   Custom Page Interactions - UI Match
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  
  // ========================================
  // 1. Scroll Reveal Animations
  // ========================================
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Add animation classes to sections (homepage custom hero/sections only)
  var isTemplateIndex = document.body.classList.contains('template-index');
  if (isTemplateIndex) {
    var sections = document.querySelectorAll('section');
    var animationTypes = ['fade-in-up', 'fade-in-left', 'fade-in-right', 'scale-in'];

    sections.forEach(function(section, index) {
      section.classList.add(animationTypes[index % animationTypes.length]);
      observer.observe(section);
    });
  }

  // ========================================
  // 2. Hero Image Parallax Effect
  // ========================================
  var heroImage = document.querySelector('.hero-showcase img');
  if (heroImage) {
    window.addEventListener('scroll', function() {
      var scrolled = window.pageYOffset;
      if (scrolled < 600) {
        heroImage.style.transform = 'rotate(' + (2 - scrolled * 0.003) + 'deg) translateY(' + (scrolled * 0.05) + 'px)';
      }
    }, { passive: true });
  }

  // ========================================
  // 3. Stats Number Counter Animation
  // ========================================
  var statItems = document.querySelectorAll('.stats-section .stat-item p:first-child');
  var statsObserved = false;

  var statsObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && !statsObserved) {
        statsObserved = true;
        animateStats();
        statsObserver.disconnect();
      }
    });
  }, { threshold: 0.5 });

  if (statItems.length > 0) {
    statsObserver.observe(document.querySelector('.stats-section'));
  }

  function animateStats() {
    statItems.forEach(function(stat) {
      var target = stat.getAttribute('data-target') || stat.textContent;
      var numericValue = parseFloat(target.replace(/[^0-9.]/g, ''));
      var suffix = target.replace(/[0-9.,]/g, '');
      
      if (isNaN(numericValue)) return;

      // Set fixed width to prevent layout shift
      var originalWidth = stat.offsetWidth;
      stat.style.minWidth = originalWidth + 'px';
      
      var duration = 2000;
      var startTime = null;

      function animate(currentTime) {
        if (!startTime) startTime = currentTime;
        var progress = Math.min((currentTime - startTime) / duration, 1);
        
        // Easing function (ease-out)
        var easeOut = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(numericValue * easeOut);
        
        stat.textContent = current.toLocaleString() + suffix;
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Remove fixed width after animation completes
          setTimeout(function() {
            stat.style.minWidth = '';
          }, 100);
        }
      }

      requestAnimationFrame(animate);
    });
  }

  // ========================================
  // 4. Product Cards Hover Effect
  // ========================================
  var productCards = document.querySelectorAll('.product-showcase > div > div:first-child > div');
  productCards.forEach(function(card, index) {
    card.classList.add('product-card');
    
    card.addEventListener('mouseenter', function() {
      this.style.zIndex = '10';
    });
    
    card.addEventListener('mouseleave', function() {
      this.style.zIndex = '1';
    });
  });

  // ========================================
  // 5. Feature Items Animation
  // ========================================
  var featureItems = document.querySelectorAll('.features-section > div > div > div:first-child > div');
  featureItems.forEach(function(item, index) {
    item.classList.add('feature-item');
    item.style.transitionDelay = (index * 100) + 'ms';
  });

  // ========================================
  // 6. Testimonial Cards Staggered Animation
  // ========================================
  var testimonialCards = document.querySelectorAll('.testimonials-section > div > div:last-of-type > div');
  testimonialCards.forEach(function(card, index) {
    card.style.transitionDelay = (index * 120) + 'ms';
  });

  // ========================================
  // 7. FAQ Accordion Enhancement
  // ========================================
  var faqDetails = document.querySelectorAll('.faq-section details');
  faqDetails.forEach(function(detail) {
    var answer = detail.querySelector('div:last-child');
    if (answer) {
      answer.classList.add('faq-answer');
    }

    detail.addEventListener('toggle', function() {
      if (this.open) {
        // Close other open FAQs
        faqDetails.forEach(function(otherDetail) {
          if (otherDetail !== detail && otherDetail.open) {
            otherDetail.removeAttribute('open');
          }
        });
      }
    });
  });

  // ========================================
  // 8. Smooth Scroll for Anchor Links
  // ========================================
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      var targetElement = document.querySelector(targetId);
      if (targetElement) {
        var offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });

  // ========================================
  // 9. Button Click Ripple Effect
  // ========================================
  document.querySelectorAll('.hero-showcase a, .product-showcase button, .faq-section a').forEach(function(button) {
    button.addEventListener('click', function(e) {
      var rect = this.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      
      var ripple = document.createElement('span');
      ripple.style.cssText = 
        'position:absolute;border-radius:50%;background:rgba(255,255,255,0.4);' +
        'width:0;height:0;left:' + x + 'px;top:' + y + 'px;' +
        'transform:translate(-50%,-50%);animation:ripple 0.6s ease-out;pointer-events:none;';
      
      this.style.position = 'relative';
      this.style.overflow = 'hidden';
      this.appendChild(ripple);
      
      setTimeout(function() {
        ripple.remove();
      }, 600);
    });
  });

  // Add ripple keyframe dynamically
  var styleSheet = document.createElement('style');
  styleSheet.textContent = '@keyframes ripple{to{width:300px;height:300px;opacity:0;}}';
  document.head.appendChild(styleSheet);

  // ========================================
  // 10. Image Load Enhancement (no lazy load - prevent flash)
  // ========================================
  // Applied to homepage only so article/product body images are never hidden
  if (isTemplateIndex) {
    var images = document.querySelectorAll('img[src*="unsplash"], img[src*="cdn"]');
    images.forEach(function(img) {
      if (!img.complete) {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.4s ease';
        img.addEventListener('load', function() {
          this.style.opacity = '1';
        });
      }
    });
  }

  console.log('[Custom Interactions] All animations and effects initialized successfully.');
});
